import { Button, FormControl } from '@material-ui/core';
import styled from 'styled-components';

interface Iprops {
  identificationKeyError?: boolean;
  ownershipTypeError?: boolean;
}

export const Container = styled.div`
  background: #201f1f;

  .select-empresas {
    width: 30%;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;

    h1 {
      font-size: 24px;
      margin-bottom: 40px;
    }

    img {
      height: 50px;
      margin-bottom: 40px;
    }

    button {
      margin-top: 40px;
      margin-left: auto;
      margin-bottom: 20px;
    }
  }
`;

export const StyledButton = styled(Button)`
  background: linear-gradient(45deg, #135db4 30%, #1473e6 90%);
  padding: 7px 14px;
  border-radius: 24px !important;
  height: 40px;
  width: 120px;

  & .MuiButton-label {
    color: #fff;
  }
`;

export const FormControlLGPD = styled(FormControl)<Iprops>`
  width: 100%;

  & + div {
    margin-left: 30px;
  }

  .MuiSelect-root {
    text-transform: uppercase;
  }

  label {
    color: ${props =>
      props.ownershipTypeError
        ? '#c53030 !important'
        : 'rgba(0, 0, 0, 0.87) !important'};
  }

  .MuiInputBase-root {
    color: ${props =>
      props.ownershipTypeError
        ? '#c53030 !important'
        : 'rgba(0, 0, 0, 0.87) !important'};

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${props =>
        props.ownershipTypeError ? '#c53030' : 'rgba(0, 0, 0, 0.87)'};
    }

    svg {
      top: 20px;
      color: ${props =>
        props.ownershipTypeError
          ? '#c53030 !important'
          : 'rgba(0, 0, 0, 0.87)'};
    }
    font-size: 14px;

    fieldset {
      border-color: ${props =>
        props.ownershipTypeError
          ? '#c53030 !important'
          : 'rgba(0, 0, 0, 0.87)'};

      &:hover fieldset {
        border-color: ${props =>
          props.ownershipTypeError ? '#c53030' : 'rgba(0, 0, 0, 0.87)'};
      }

      legend {
        border-bottom: 0;
        width: auto !important;
      }
    }

    &.Mui-focused fieldset {
      color: red;
      border-color: ${props =>
        props.ownershipTypeError ? '#c53030 !important' : '#1535ff !important'};
    }
  }

  label.focused {
    background-color: #1535ff !important;
    padding: 14.5px 14px;
  }

  .MuiFormLabel-root {
    font-size: 14px;
    text-align: center;
    padding: 2px 10px;
    margin-left: -5px;
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.ownershipTypeError ? '#c53030 !important' : '#1535ff !important'};
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${props =>
      props.ownershipTypeError ? '#c53030 !important' : ' #a2a3a5 !important'};
  }

  .MuiInputLabel-outlined {
    color: ${props => (props.ownershipTypeError ? '#c53030' : ' #a2a3a5')};
  }

  padding: 2px 10px;
  margin-left: -5px;

  .MuiSelect-select:not([multiple]) option,
  .MuiSelect-select:not([multiple]) optgroup {
    color: #222;
  }
`;
